/* eslint-disable */
export const waitForElementToExist = ({ selector, targetDocument = document, disconnect = true }) => {
	return new Promise(resolve => {
		if (targetDocument.querySelector(selector)) {
			return resolve(targetDocument.querySelector(selector));
		}

		const observer = new MutationObserver(() => {
			// wait for all elements matching the selector to exist
			if (targetDocument.querySelector(selector)) {
				resolve(targetDocument.querySelector(selector));
				disconnect && observer.disconnect();
			}
		});

		observer.observe(document.body, {
			subtree: true,
			childList: true,
		});
	});
}

export const onRemove = ({ selector, targetDocument = document, disconnect = true }) => {
	return new Promise(resolve => {
		if (!targetDocument.querySelector(selector)) {
			return resolve();
		}

		const observer = new MutationObserver(() => {
			// wait for all elements matching the selector to exist
			if (!targetDocument.querySelector(selector)) {
				resolve();
				disconnect && observer.disconnect();
			}
		});

		observer.observe(document.body, {
			subtree: true,
			childList: true,
		});
	});
}